/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useConsoleServiceStore } from 'dxpConsoleCore-mf/State';
import React, { useEffect } from 'react';
import { lastValueFrom } from 'rxjs';
import { getAuthService } from '../../Services/auth';
import { LOCAL_STORAGE_KEY_DXP_SERVICE_TOKENS } from '../../Services/console';
import { getIdentityGatewayService } from '../../Services/identity-gateway';

/**
 * Logout.
 * This will log the user out and redirect the app to the login screen.
 * @export
 * @returns {JSX.Element} The `<Logout />` component.
 */
export const Logout = (): JSX.Element => {
  // Auth service
  const authService = getAuthService();

  // Identity gateway service
  const identityGatewayService = getIdentityGatewayService();

  // Console service
  const { updateTokens } = useConsoleServiceStore();

  // Attempt to destroy the DXP session.
  // Regardless of outcome, continue logout process.
  useEffect(() => {
    // Clear tokens from local storage.
    localStorage.removeItem(LOCAL_STORAGE_KEY_DXP_SERVICE_TOKENS);
    updateTokens(null);

    lastValueFrom(identityGatewayService.logOutOfDxp())
      .then(() => {
        // Attempt Auth0 logout
        authService.logout();
        return true;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);

        // Attempt Auth0 logout
        authService.logout();
      });
  }, [authService, identityGatewayService, updateTokens]);

  return <></>;
};
